import { Plugin, PluginKey } from 'prosemirror-state';
import { setAttribute } from '../utils';
var setAttributes = function (dom, attrs) {
    for (var attrName in attrs) {
        if (attrName) {
            setAttribute(dom, attrName, attrs[attrName]);
        }
    }
};
var CustomNodeView = /** @class */ (function () {
    function CustomNodeView(node, view, nodeName, isLeaf) {
        if (isLeaf === void 0) { isLeaf = false; }
        this.node = node;
        this.view = view;
        this.dom = document.createElement(nodeName);
        setAttributes(this.dom, node.attrs);
        this.contentDOM = !isLeaf ? this.dom : undefined;
    }
    return CustomNodeView;
}());
var StyleView = /** @class */ (function () {
    function StyleView(mark, view) {
        this.mark = mark;
        this.view = view;
        this.dom = document.createElement('span');
        setAttributes(this.dom, mark.attrs);
        this.contentDOM = this.dom;
    }
    return StyleView;
}());
export var cspFix = function () {
    return new Plugin({
        key: new PluginKey('csp-fix'),
        props: {
            nodeViews: {
                paragraph: function (node, view) { return new CustomNodeView(node, view, 'p'); },
                div: function (node, view) { return new CustomNodeView(node, view, 'div'); },
                table_wrapper: function (node, view) { return new CustomNodeView(node, view, 'div'); },
                table_caption_external: function (node, view) { return new CustomNodeView(node, view, 'div'); },
                table: function (node, view) { return new CustomNodeView(node, view, 'table'); },
                table_row: function (node, view) { return new CustomNodeView(node, view, 'tr'); },
                table_cell: function (node, view) { return new CustomNodeView(node, view, 'td'); },
                table_header: function (node, view) { return new CustomNodeView(node, view, 'th'); },
                image: function (node, view) { return new CustomNodeView(node, view, 'img', true); }
            },
            markViews: {
                style: function (mark, view) { return new StyleView(mark, view); }
            }
        }
    });
};
